import React from 'react';
import { SEO } from '../components/shared/SEO';
import { ScrollToTopSection } from './product-diy/ScrollToTopSection';
import { EyebrowSection } from './product-diy/EyebrowSection';
import { HeaderSection } from './product-diy/HeaderSection';
import { ProductHeroSection } from './product-diy/ProductHeroSection';
import { TechSpecsBandSection } from './product-complete/TechSpecsBandSection';
import { PressureControlSection } from './product-complete/PressureControlSection';
import { WhatsIncludedSection } from './product-diy/WhatsIncludedSection';
import { TechnicalSpecsSection } from './product-complete/TechnicalSpecsSection';
import { WhyChooseSection } from './product-complete/WhyChooseSection';
import { WhoItsForSection } from './product-complete/WhoItsForSection';
import { FinalCTASection } from './product-complete/FinalCTASection';
import { FooterSection } from './product-diy/FooterSection';
export function ProductDIYKit() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-950">
      <ScrollToTopSection data-id="element-951" />
      <SEO title="ForceX DIY Kit | Precision Pro Sprayers" description="Build it your way. The flexible solution for contractors who want to customize their setup." data-id="element-952" />
      <EyebrowSection data-id="element-953" />
      <HeaderSection data-id="element-954" />
      <main className="flex-grow" data-id="element-955">
        <ProductHeroSection data-id="element-956" />
        <TechSpecsBandSection data-id="element-957" />
        <PressureControlSection data-id="element-958" />
        <WhatsIncludedSection data-id="element-959" />
        <TechnicalSpecsSection data-id="element-960" />
        <WhyChooseSection data-id="element-961" />
        <WhoItsForSection data-id="element-962" />
        <FinalCTASection data-id="element-963" />
      </main>
      <FooterSection data-id="element-964" />
    </div>;
}